import React from "react";

import { formatCurrency } from "../utils/utils";

export default ({ base, percIva, iva, total }) => {
  return (
    <div className="sale-table-item sale-table-ivas">
      <div>{formatCurrency(base)}</div>
      <div>{percIva} %</div>
      <div>{formatCurrency(iva)}</div>
      <div>{formatCurrency(total)}</div>
    </div>
  );
};
